module.exports = __webpack_public_path__ + "img/ic-arrow-previous.1aaa4b6d.svg";